import { Flex } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";

export const ListWrapper = ({ children }: { children: React.ReactNode }) => {
  const { isMobile } = useAntTheme();
  return (
    <Flex
      gap={24}
      style={{
        flexDirection: isMobile ? "column-reverse" : "row",
        marginTop: 30,
      }}
    >
      {children}
    </Flex>
  );
};
